import { BulkCaseEventCreateRequest, CaseEventsAPI, CaseEventsResponse } from "../../../api/events";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const addCaseEvents = createAsyncThunk<
  CaseEventsResponse,
  { case_id: string, request: BulkCaseEventCreateRequest },
  { rejectValue: void }
>(
  "caseEvents/addCaseEvents",
  async ({ case_id, request }, { rejectWithValue }) => {
    try {
      return await CaseEventsAPI.addCaseEvents(case_id, request);
    } catch (error) {
      console.error(error);
      return rejectWithValue();
    }
  }
);